import {Component, signal} from '@angular/core';
import {TeamsService} from '../../services/teams.service';
import {Team} from '../../models/team';
import {FormsModule} from '@angular/forms';
import {NbSelectModule, NbSpinnerModule} from '@nebular/theme';
import {Division} from '../../models/division';
import {DivisionSelectorComponent} from '../../shared/components/division-selector/division-selector.component';
import {Utils} from '../../shared/utils';
import {TeamsListComponent} from "./components/teams-list/teams-list.component";
import {StorageService} from "../../services/storage.service";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-teams',
  standalone: true,
  imports: [
    TranslateModule,NbSelectModule, FormsModule, DivisionSelectorComponent, TeamsListComponent, NbSpinnerModule],
  templateUrl: './teams.component.html',
  styleUrl: './teams.component.scss'
})
export class TeamsComponent {
  loading = false;
  isLoggedIn = false;
  selectedDivisionId = signal<string>('');
  teamsA = signal<Team[]>([]);
  teamsB = signal<Team[]>([]);
  teamsC = signal<Team[]>([]);
  teamsD = signal<Team[]>([]);
  divisions = signal<Division[]>([]);
  groups = signal<Division[]>([]);

  constructor(public utils: Utils, private storageService: StorageService, private teamsService: TeamsService) {}

  ngOnInit(): void {
    this.isLoggedIn = this.storageService.isLoggedIn();
    this.teamsService.divisions().subscribe((divisions: any) => {
      this.divisions.set(divisions);
      setTimeout(() => {
        Utils.setFirstDivisionForSignal(this.selectedDivisionId, divisions);
        const saved = this.storageService.getSelectedDivisionId();
        if (saved) {
          this.selectedDivisionId.set(saved);
        }
        this.search();
      });
    });
  }

  onDivisionChange($event: any) {
    this.selectedDivisionId.set($event);
    this.storageService.storeSelectedDivisionId(this.selectedDivisionId())
    this.teamsService.groupsByDivision(this.selectedDivisionId()).subscribe((result) => {
      this.groups.set(result);
      this.search();
    });
  }

  search() {
    this.loading = true;
    this.teamsService.teamsByGroup(this.selectedDivisionId()).subscribe((response: any) => {
      const teamsA: Team[] = [];
      const teamsB: Team[] = [];
      const teamsC: Team[] = [];
      const teamsD: Team[] = [];

      response.forEach((data: any) => {
        if (data.group_id == 'A') {
          teamsA.push(data);
        }
        else if (data.group_id == 'B') {
          teamsB.push(data);
        }
        else if (data.group_id == 'C') {
          teamsC.push(data);
        }
        else if (data.group_id == 'D') {
          teamsD.push(data);
        }
      });
      this.teamsA.set(teamsA);
      this.teamsB.set(teamsB);
      this.teamsC.set(teamsC);
      this.teamsD.set(teamsD);

      this.loading = false;
    });
  }
}
